// import React, { useState, useRef, useEffect } from "react"
// import { Container, Row, Col,
//   Button,
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   FormGroup,
//   Label,
//   Input,
// } from "reactstrap";
// import { Card } from "primereact/card";
// import { useLocation, useNavigate } from "react-router-dom";
// import { ProgressSpinner } from "primereact/progressspinner";

// const JobTimeLineView = () => {
//      const location = useLocation();
//     const [timelineData, setTimelineData] = useState(location.state?.timelineData || []);
//     const [loading, setLoading] = useState(!(Array.isArray(location.state?.timelineData) && location.state.timelineData.length > 0));

//     useEffect(() => {
//     const incoming = location.state?.timelineData || [];
//     setTimelineData(incoming);
//   }, [location.state]);

  
//   useEffect(() => {
//     if (Array.isArray(timelineData) && timelineData.length > 0) {
//       setLoading(false);
//     } else {
//       setLoading(true); 
//     }
//   }, [timelineData]);


//     const navigate = useNavigate()
//     return (
       

//         <Container fluid className="page-content">

//              {loading  ? (
//               <div className="w-100 text-center d-flex align-items-center justify-content-center" style={{ height: "80vh" }}>
//                   <ProgressSpinner />
//                 </div>
//               ) : (
//                <div className="page-title-box mb-0 recruiter-dashboard">
//                  <Row className="d-flex justify-content-end">
//                     <Col xs="auto">
//                         <button onClick={() => navigate("/all-job-orders")} className="btn btn-primary">
//                             Back
//                         </button>
//                     </Col>
//                 </Row>

//                 <Row>
//                     <Col xxl={6} className="d-none">
//                         <Card className="mb-3 shadow-md border-0 p-1">
//                             <h1 className="page-title mb-4" style={{ fontSize: "16px"}}>Job Time Line View 1</h1>
//                             <Row>
//                                 <Col xxl={12}>
//                                     <div className="JobTimeLineContainer">
//                                         <div className="JobTimeLineBlock ps-3 mb-4">
//                                             <div className="shadow p-3 rounded">
//                                                 <div className="JobTimeLine_ActionType">Job Created</div>
//                                                 <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                                 <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4">
//                                             <div className="shadow p-3 rounded">
//                                                 <div className="JobTimeLine_ActionType">Added Candidate</div>
//                                                 <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                                 <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4">
//                                             <div className="shadow p-3 rounded">
//                                                 <div className="JobTimeLine_ActionType">Added Candidate - Shekar</div>
//                                                 <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                                 <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4">
//                                             <div className="shadow p-3 rounded">
//                                                 <div className="JobTimeLine_ActionType">Added Candidate - Ravi</div>
//                                                 <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                                 <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4">
//                                             <div className="shadow p-3 rounded">
//                                                 <div className="JobTimeLine_ActionType">Added Candidate - Sai</div>
//                                                 <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                                 <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4">
//                                             <div className="shadow p-3 rounded">
//                                                 <div className="JobTimeLine_ActionType">Removed Candidate from Job</div>
//                                                 <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                                 <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4">
//                                             <div className="shadow p-3 rounded">
//                                                 <div className="JobTimeLine_ActionType">Removed Candidate from Job - Shekar</div>
//                                                 <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                                 <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4">
//                                             <div className="shadow p-3 rounded">
//                                                 <div className="JobTimeLine_ActionType">Test send to candidate</div>
//                                                 <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                                 <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4">
//                                             <div className="shadow p-3 rounded">
//                                                 <div className="JobTimeLine_ActionType">Candidate details edit</div>
//                                                 <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                                 <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4">
//                                             <div className="shadow p-3 rounded">
//                                                 <div className="JobTimeLine_ActionType">Candidate test completed</div>
//                                                 <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                                 <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4">
//                                             <div className="shadow p-3 rounded">
//                                                 <div className="JobTimeLine_ActionType">Candidate interview schedule</div>
//                                                 <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                                 <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4">
//                                             <div className="shadow p-3 rounded">
//                                                 <div className="JobTimeLine_ActionType">Candidate moved from open to placed</div>
//                                                 <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                                 <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4">
//                                             <div className="shadow p-3 rounded">
//                                                 <div className="JobTimeLine_ActionType">Updated Job on : 10/11/2025 12:17 PM</div>
//                                                 <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                                 <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4">
//                                             <div className="shadow p-3 rounded">
//                                                 <div className="JobTimeLine_ActionType">Assigned to Shekar</div>
//                                                 <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                                 <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                             </div>
//                                         </div>
                                        
//                                         <div className="JobTimeLineBlock ps-3 mb-4">
//                                             <div className="shadow p-3 rounded">
//                                                 <div className="JobTimeLine_ActionType text-danger">Job Closed on: 11/11/2025 5:59 PM</div>
//                                                 <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                                 <div className="JobTimeLine_ActionDateTime">15/11/2025 11:59 PM</div>
//                                             </div>
//                                         </div>
                                        
//                                     </div>
//                                 </Col>
//                             </Row>
//                         </Card>
//                     </Col>
//                     <Col xxl={6}>
//                         <Card className="mb-3 shadow-md border-0 p-1">
//                             <h1 className="page-title mb-4" style={{ fontSize: "16px"}}>Job Time Line View</h1>
//                             {timelineData.map((log, index) => (
//                             <Row>
//                                 <Col xxl={12}>
//                                     <div className="JobTimeLineContainer">
//                                         <div className="JobTimeLineBlock ps-3 mb-4">
//                                             <div className="shadow p-3 rounded">
//                                                 <Row>
//                                                     <Col xxl={9}>
//                                                         <div className="JobTimeLine_ActionType">{log.action_type}</div>
//                                                         <div className="JobTimeLine_ActionType">{log.description}</div>
//                                                     </Col>
//                                                     <Col xxl={3} className="text-end px-0">
//                                                         <div className="p-2 bg_blue text-white rounded">
//                                                             <div className="JobTimeLine_CreaedBy  text-white">{log.actioned_by_name}</div>
//                                                             <div className="JobTimeLine_ActionDateTime  text-white">{log.action_date}</div>
//                                                         </div>
//                                                     </Col>
//                                                 </Row>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4 d-none">
//                                             <div className="shadow p-3 rounded">
//                                                 <Row>
//                                                     <Col xxl={9}>
//                                                         <div className="JobTimeLine_ActionType">Added Candidate</div>
//                                                     </Col>
//                                                     <Col xxl={3} className="text-end px-0">
//                                                         <div className="p-2 bg_blue text-white rounded">
//                                                             <div className="JobTimeLine_CreaedBy  text-white">Chandu</div>
//                                                             <div className="JobTimeLine_ActionDateTime  text-white">10/11/2025 12:17 PM</div>
//                                                         </div>
//                                                     </Col>
//                                                 </Row>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4 d-none">
//                                             <div className="shadow p-3 rounded">
//                                                 <Row>
//                                                     <Col xxl={9}>
//                                                         <div className="JobTimeLine_ActionType">Added Candidate - Shekar</div>
//                                                     </Col>
//                                                     <Col xxl={3} className="text-end px-0">
//                                                         <div className="p-2 bg_blue text-white rounded">
//                                                             <div className="JobTimeLine_CreaedBy  text-white">Chandu</div>
//                                                             <div className="JobTimeLine_ActionDateTime  text-white">10/11/2025 12:17 PM</div>
//                                                         </div>
//                                                     </Col>
//                                                 </Row>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4 d-none">
//                                             <div className="shadow p-3 rounded">
//                                                 <Row>
//                                                     <Col xxl={9}>
//                                                         <div className="JobTimeLine_ActionType">Added Candidate - Ravi</div>
//                                                     </Col>
//                                                     <Col xxl={3} className="text-end px-0">
//                                                         <div className="p-2 bg_blue text-white rounded">
//                                                             <div className="JobTimeLine_CreaedBy  text-white">Chandu</div>
//                                                             <div className="JobTimeLine_ActionDateTime  text-white">10/11/2025 12:17 PM</div>
//                                                         </div>
//                                                     </Col>
//                                                 </Row>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4 d-none">
//                                             <div className="shadow p-3 rounded">
//                                                 <Row>
//                                                     <Col xxl={9}>
//                                                         <div className="JobTimeLine_ActionType">Added Candidate - Sai</div>
//                                                     </Col>
//                                                     <Col xxl={3} className="text-end px-0">
//                                                         <div className="p-2 bg_blue text-white rounded">
//                                                             <div className="JobTimeLine_CreaedBy  text-white">Chandu</div>
//                                                             <div className="JobTimeLine_ActionDateTime  text-white">10/11/2025 12:17 PM</div>
//                                                         </div>
//                                                     </Col>
//                                                 </Row>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4 d-none">
//                                             <div className="shadow p-3 rounded">
//                                                 <Row>
//                                                     <Col xxl={9}>
//                                                         <div className="JobTimeLine_ActionType">Removed Candidate from Job</div>
//                                                     </Col>
//                                                     <Col xxl={3} className="text-end px-0">
//                                                         <div className="p-2 bg_blue text-white rounded">
//                                                             <div className="JobTimeLine_CreaedBy  text-white">Chandu</div>
//                                                             <div className="JobTimeLine_ActionDateTime  text-white">10/11/2025 12:17 PM</div>
//                                                         </div>
//                                                     </Col>
//                                                 </Row>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4 d-none">
//                                             <div className="shadow p-3 rounded">
//                                                 <Row>
//                                                     <Col xxl={9}>
//                                                         <div className="JobTimeLine_ActionType">Removed Candidate from Job - Sai</div>
//                                                     </Col>
//                                                     <Col xxl={3} className="text-end px-0">
//                                                         <div className="p-2 bg_blue text-white rounded">
//                                                             <div className="JobTimeLine_CreaedBy  text-white">Chandu</div>
//                                                             <div className="JobTimeLine_ActionDateTime  text-white">10/11/2025 12:17 PM</div>
//                                                         </div>
//                                                     </Col>
//                                                 </Row>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4 d-none">
//                                             <div className="shadow p-3 rounded">
//                                                 <Row>
//                                                     <Col xxl={9}>
//                                                         <div className="JobTimeLine_ActionType">Updated Job on : 10/11/2025 12:17 PM</div>
//                                                     </Col>
//                                                     <Col xxl={3} className="text-end px-0">
//                                                         <div className="p-2 bg_blue text-white rounded">
//                                                             <div className="JobTimeLine_CreaedBy  text-white">Chandu</div>
//                                                             <div className="JobTimeLine_ActionDateTime  text-white">10/11/2025 12:17 PM</div>
//                                                         </div>
//                                                     </Col>
//                                                 </Row>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4 d-none">
//                                             <div className="shadow p-3 rounded">
//                                                 <Row>
//                                                     <Col xxl={9}>
//                                                         <div className="JobTimeLine_ActionType">Assigned to Shekar</div>
//                                                     </Col>
//                                                     <Col xxl={3} className="text-end px-0">
//                                                         <div className="p-2 bg_blue text-white rounded">
//                                                             <div className="JobTimeLine_CreaedBy  text-white">Chandu</div>
//                                                             <div className="JobTimeLine_ActionDateTime  text-white">10/11/2025 12:17 PM</div>
//                                                         </div>
//                                                     </Col>
//                                                 </Row>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4 d-none">
//                                             <div className="shadow p-3 rounded">
//                                                 <Row>
//                                                     <Col xxl={9}>
//                                                         <div className="JobTimeLine_ActionType text-danger">Job will Expired on: 15/11/2025 11:59 PM</div>
//                                                     </Col>
//                                                     <Col xxl={3} className="text-end px-0">
//                                                         <div className="p-2 bg-danger text-white rounded">
//                                                             <div className="JobTimeLine_CreaedBy  text-white">Chandu</div>
//                                                             <div className="JobTimeLine_ActionDateTime  text-white">10/11/2025 12:17 PM</div>
//                                                         </div>
//                                                     </Col>
//                                                 </Row>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </Col>
//                             </Row>))}
//                         </Card>
//                     </Col>
//                     <Col xxl={6} className="d-none">
//                         <Card className="mb-3 shadow-md border-0 p-1">
//                             <h1 className="page-title mb-4" style={{ fontSize: "16px"}}>Job Time Line View 2</h1>
//                             <Row>
//                                 <Col xxl={12}>
//                                     <div className="JobTimeLineContainer">
//                                         <div className="JobTimeLineBlock ps-3 mb-4">
//                                             <div className="shadow p-3 rounded">
//                                                 <Row>
//                                                     <Col xxl={9}>
//                                                         <div className="JobTimeLine_ActionType">Job Created</div>
//                                                     </Col>
//                                                     <Col xxl={3} className="text-end">
//                                                         <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                                         <div className="JobTimeLine_ActionDateTime">09/11/2025 12:17 PM</div>
//                                                     </Col>
//                                                 </Row>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4">
//                                             <div className="shadow p-3 rounded">
//                                                 <Row>
//                                                     <Col xxl={9}>
//                                                         <div className="JobTimeLine_ActionType">Added Candidate</div>
//                                                     </Col>
//                                                     <Col xxl={3} className="text-end">
//                                                         <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                                         <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                                     </Col>
//                                                 </Row>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4">
//                                             <div className="shadow p-3 rounded">
//                                                 <Row>
//                                                     <Col xxl={9}>
//                                                         <div className="JobTimeLine_ActionType">Added Candidate - Shekar</div>
//                                                     </Col>
//                                                     <Col xxl={3} className="text-end">
//                                                         <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                                         <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                                     </Col>
//                                                 </Row>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4">
//                                             <div className="shadow p-3 rounded">
//                                                 <Row>
//                                                     <Col xxl={9}>
//                                                         <div className="JobTimeLine_ActionType">Added Candidate - Ravi</div>
//                                                     </Col>
//                                                     <Col xxl={3} className="text-end">
//                                                         <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                                         <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                                     </Col>
//                                                 </Row>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4">
//                                             <div className="shadow p-3 rounded">
//                                                 <Row>
//                                                     <Col xxl={9}>
//                                                         <div className="JobTimeLine_ActionType">Added Candidate - Sai</div>
//                                                     </Col>
//                                                     <Col xxl={3} className="text-end">
//                                                         <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                                         <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                                     </Col>
//                                                 </Row>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4">
//                                             <div className="shadow p-3 rounded">
//                                                 <Row>
//                                                     <Col xxl={9}>
//                                                         <div className="JobTimeLine_ActionType">Removed Candidate from Job</div>
//                                                     </Col>
//                                                     <Col xxl={3} className="text-end">
//                                                         <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                                         <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                                     </Col>
//                                                 </Row>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4">
//                                             <div className="shadow p-3 rounded">
//                                                 <Row>
//                                                     <Col xxl={9}>
//                                                         <div className="JobTimeLine_ActionType">Removed Candidate from Job - Sai</div>
//                                                     </Col>
//                                                     <Col xxl={3} className="text-end">
//                                                         <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                                         <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                                     </Col>
//                                                 </Row>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4">
//                                             <div className="shadow p-3 rounded">
//                                                 <Row>
//                                                     <Col xxl={9}>
//                                                         <div className="JobTimeLine_ActionType">Updated Job on : 10/11/2025 12:17 PM</div>
//                                                     </Col>
//                                                     <Col xxl={3} className="text-end">
//                                                         <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                                         <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                                     </Col>
//                                                 </Row>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4">
//                                             <div className="shadow p-3 rounded">
//                                                 <Row>
//                                                     <Col xxl={9}>
//                                                         <div className="JobTimeLine_ActionType">Assigned to Shekar</div>
//                                                     </Col>
//                                                     <Col xxl={3} className="text-end">
//                                                         <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                                         <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                                     </Col>
//                                                 </Row>
//                                             </div>
//                                         </div>

//                                         <div className="JobTimeLineBlock ps-3 mb-4">
//                                             <div className="shadow p-3 rounded">
//                                                 <Row>
//                                                     <Col xxl={9}>
//                                                         <div className="JobTimeLine_ActionType text-danger">Job will Expired on: 15/11/2025 11:59 PM</div>
//                                                     </Col>
//                                                     <Col xxl={3} className="text-end">
//                                                         <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                                         <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                                     </Col>
//                                                 </Row>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </Col>
//                             </Row>
//                         </Card>
//                     </Col>
//                 </Row>

                
                
                

                
                
//                 <Card className="mb-3 shadow-md border-0 p-1 d-none">
//                     <h1 className="page-title mb-4" style={{ fontSize: "16px"}}>Job Time Line View 4</h1>
//                     <Row>
//                         <Col xxl={6}>
//                             <div className="JobTimeLineContainer">
//                                 <div className="JobTimeLineBlock ps-3 mb-4">
//                                     <div className="shadow p-3 rounded">
//                                         <div className="JobTimeLine_ActionType">Job Created</div>
//                                         <div className="TimeStamp p-2 rounded">
//                                             <div className="JobTimeLine_Actioned_By">Action By</div>
//                                             <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                             <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="JobTimeLineBlock ps-3 mb-4">
//                                     <div className="shadow p-3 rounded">
//                                         <div className="JobTimeLine_ActionType">Added Candidate</div>
//                                         <div className="TimeStamp p-2 rounded">
//                                             <div className="JobTimeLine_Actioned_By">Action By</div>
//                                             <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                             <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="JobTimeLineBlock ps-3 mb-4">
//                                     <div className="shadow p-3 rounded">
//                                         <div className="JobTimeLine_ActionType">Updated Job on : 10/11/2025 12:17 PM</div>
//                                         <div className="TimeStamp p-2 rounded">
//                                             <div className="JobTimeLine_Actioned_By">Action By</div>
//                                             <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                             <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="JobTimeLineBlock ps-3 mb-4">
//                                     <div className="shadow p-3 rounded">
//                                         <div className="JobTimeLine_ActionType">Assigned to Shekar</div>
//                                         <div className="TimeStamp p-2 rounded">
//                                             <div className="JobTimeLine_Actioned_By">Action By</div>
//                                             <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                             <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="JobTimeLineBlock ps-3 mb-4">
//                                     <div className="shadow p-3 rounded">
//                                         <div className="JobTimeLine_ActionType">Removed Candidate from Job</div>
//                                         <div className="TimeStamp p-2 rounded">
//                                             <div className="JobTimeLine_Actioned_By">Action By</div>
//                                             <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                             <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="JobTimeLineBlock ps-3 mb-4">
//                                     <div className="shadow p-3 rounded">
//                                         <div className="JobTimeLine_ActionType">Removed Candidate from Job - Shekar</div>
//                                         <div className="TimeStamp p-2 rounded">
//                                             <div className="JobTimeLine_Actioned_By">Action By</div>
//                                             <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                             <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="JobTimeLineBlock ps-3 mb-4">
//                                     <div className="shadow p-3 rounded">
//                                         <div className="JobTimeLine_ActionType text-danger">Job will expired on: 15/11/2025 11:59 PM</div>
//                                         <div className="TimeStamp p-2 rounded">
//                                             <div className="JobTimeLine_Actioned_By">Action By</div>
//                                             <div className="JobTimeLine_CreaedBy">Chandu</div>
//                                             <div className="JobTimeLine_ActionDateTime">10/11/2025 12:17 PM</div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </Col>
//                     </Row>
//                 </Card>

                
//             </div>  
//         )}

           
//         </Container>       
//     )
// }

// export default JobTimeLineView;


import React, { useState, useEffect } from "react"
import { Container, Row, Col, Card } from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";

const JobTimeLineView = () => {
  const location = useLocation();
  const [timelineData, setTimelineData] = useState(location.state?.timelineData || []);
  const [loading, setLoading] = useState(!(Array.isArray(location.state?.timelineData) && location.state.timelineData.length > 0));

  useEffect(() => {
    const incoming = location.state?.timelineData || [];
    setTimelineData(incoming);
  }, [location.state]);

  useEffect(() => {
    if (Array.isArray(timelineData) && timelineData.length > 0) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [timelineData]);

  const navigate = useNavigate();

  // Color + icon + label config per action category
  const EVENT_STYLES = {
    created:  { badge: "#185fa5", bg: "#e6f1fb", border: "#b5d4f4", title: "#0c447c", body: "#185fa5", icon: "fa-briefcase",        label: "Created" },
    candidate:{ badge: "#639922", bg: "#eaf3de", border: "#c0dd97", title: "#27500a", body: "#3b6d11", icon: "fa-user-plus",        label: "Candidate" },
    test:     { badge: "#534ab7", bg: "#eeedfe", border: "#cecbf6", title: "#3c3489", body: "#534ab7", icon: "fa-file-text-o",      label: "Test" },
    stage:    { badge: "#d97706", bg: "#faeeda", border: "#fac775", title: "#633806", body: "#854f0b", icon: "fa-exchange",         label: "Stage change" },
    removed:  { badge: "#d85a30", bg: "#faece7", border: "#f5c4b3", title: "#712b13", body: "#993c1d", icon: "fa-user-times",       label: "Removed" },
    closed:   { badge: "#e24b4a", bg: "#fcebeb", border: "#f7c1c1", title: "#791f1f", body: "#a32d2d", icon: "fa-lock",             label: "Closed" },
    default:  { badge: "#5f5e5a", bg: "#f1efe8", border: "#d3d1c7", title: "#444441", body: "#5f5e5a", icon: "fa-circle-o",         label: "Update" },
  };

  const getEventStyle = (actionType) => {
    const t = String(actionType || "").toLowerCase();
    if (t.includes("created") || t.includes("posted")) return EVENT_STYLES.created;
    if (t.includes("candidate") && (t.includes("removed") || t.includes("delete"))) return EVENT_STYLES.removed;
    if (t.includes("candidate")) return EVENT_STYLES.candidate;
    if (t.includes("test") || t.includes("screen")) return EVENT_STYLES.test;
    if (t.includes("stage") || t.includes("status") || t.includes("moved") || t.includes("assigned")) return EVENT_STYLES.stage;
    if (t.includes("expire") || t.includes("closed")) return EVENT_STYLES.closed;
    if (t.includes("removed")) return EVENT_STYLES.removed;
    return EVENT_STYLES.default;
  };

  const getInitials = (name) => {
    if (!name) return "--";
    const parts = String(name).trim().split(/\s+/);
    return parts.slice(0, 2).map(p => p.charAt(0).toUpperCase()).join("");
  };

  return (
    <Container fluid className="page-content">
      {loading ? (
        <div className="w-100 text-center d-flex align-items-center justify-content-center" style={{ height: "80vh" }}>
          <ProgressSpinner />
        </div>
      ) : (
        <div className="page-title-box mb-0 recruiter-dashboard">
          <Row className="d-flex justify-content-between align-items-center mb-3">
            <Col xs="auto">
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <div
                  aria-hidden="true"
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: 10,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    background: "linear-gradient(135deg, #0e527d, #168b9b)",
                    boxShadow: "0 5px 12px rgba(14, 82, 125, 0.18)",
                    fontSize: 17,
                  }}
                >
                  <i className="mdi mdi-timeline-clock-outline" />
                </div>
                <div>
                  <h5 style={{ margin: 0, fontWeight: 700, color: "#102a43", letterSpacing: "-0.2px" }}>
                    Job Timeline
                  </h5>
                  <div style={{ marginTop: 4, fontSize: 12, color: "#718096" }}>
                    Activity history for this job
                  </div>
                </div>
                <span
                  style={{
                    marginLeft: 4,
                    padding: "5px 9px",
                    borderRadius: 999,
                    background: "#e6f6f7",
                    color: "#087f8c",
                    fontSize: 12,
                    fontWeight: 700,
                    whiteSpace: "nowrap",
                  }}
                >
                  {timelineData.length} action{timelineData.length !== 1 ? "s" : ""}
                </span>
              </div>
            </Col>
            <Col xs="auto">
              <button onClick={() => navigate("/all-job-orders")} className="btn btn-primary">
                <i className="fa fa-arrow-left me-2" />
                Back
              </button>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col xxl={9} lg={11} xs={12}>
              <Card
                className="shadow-sm border-0"
                style={{ borderRadius: 14, padding: "34px 28px", background: "#fff" }}
              >
                {timelineData.length === 0 ? (
                  <div style={{ textAlign: "center", padding: "40px 0", color: "#94a3b8" }}>
                    No timeline events found for this job.
                  </div>
                ) : (
                  <div style={{ position: "relative" }}>
                    {/* Center connector line */}
                    <div
                      style={{
                        position: "absolute",
                        left: "50%",
                        top: 6,
                        bottom: 6,
                        width: 3,
                        background:
                          "linear-gradient(180deg, #85b7eb 0%, #97c459 35%, #f0997b 65%, #f09595 100%)",
                        borderRadius: 3,
                        transform: "translateX(-1.5px)",
                        opacity: 0.5,
                      }}
                    />

                    {timelineData.map((log, index) => {
                      const style = getEventStyle(log.action_type);
                      const isLeft = index % 2 === 0;
                      const isLast = index === timelineData.length - 1;

                      const CardBlock = (
                        <div
                          style={{
                            display: "inline-block",
                            background: style.bg,
                            border: `0.5px solid ${style.border}`,
                            borderRadius: 12,
                            padding: "12px 16px",
                            textAlign: "left",
                            maxWidth: 280,
                          }}
                        >
                          <span
                            style={{
                              background: style.badge,
                              color: "#fff",
                              borderRadius: 999,
                              padding: "2px 9px",
                              fontSize: 10,
                              fontWeight: 700,
                            }}
                          >
                            {style.label}
                          </span>
                          <div style={{ fontSize: 13.5, fontWeight: 700, color: style.title, margin: "6px 0 2px" }}>
                            {log.action_type || "--"}
                          </div>
                          {log.description && (
                            <div style={{ fontSize: 11.5, color: style.body, lineHeight: 1.5 }}>
                              {log.description}
                            </div>
                          )}
                          <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 10 }}>
                            <div
                              style={{
                                width: 20,
                                height: 20,
                                borderRadius: "50%",
                                background: style.badge,
                                color: "#fff",
                                fontSize: 9,
                                fontWeight: 700,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0,
                              }}
                            >
                              {getInitials(log.actioned_by_name)}
                            </div>
                            <div style={{ fontSize: 11, color: style.title, fontWeight: 600 }}>
                              {log.actioned_by_name || "--"}
                            </div>
                          </div>
                          <div style={{ fontSize: 10.5, color: style.body, marginTop: 1 }}>
                            {log.action_date || "--"}
                          </div>
                        </div>
                      );

                      return (
                        <div
                          key={index}
                          style={{
                            position: "relative",
                            display: "grid",
                            gridTemplateColumns: "1fr 44px 1fr",
                            marginBottom: isLast ? 0 : 22,
                          }}
                        >
                          <div style={{ gridColumn: 1, paddingRight: isLeft ? 20 : 0, textAlign: "right" }}>
                            {isLeft && CardBlock}
                          </div>

                          <div style={{ gridColumn: 2, display: "flex", justifyContent: "center" }}>
                            <div
                              style={{
                                width: 32,
                                height: 32,
                                borderRadius: "50%",
                                background: style.badge,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                zIndex: 1,
                                boxShadow: "0 0 0 4px #fff",
                              }}
                            >
                              <i className={`fa ${style.icon}`} style={{ fontSize: 14, color: "#fff" }} />
                            </div>
                          </div>

                          <div style={{ gridColumn: 3, paddingLeft: !isLeft ? 20 : 0 }}>
                            {!isLeft && CardBlock}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </Container>
  );
};

export default JobTimeLineView;
